export { default } from "ember-stereo/-private/utils/normalize-identifier";
